module.exports = __webpack_public_path__ + "img/20.150778e8.png";